import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Row, Col, Card } from "antd";
import LoaderGif from "../../assets/images/ie_loader.gif";
import Catalog from "../../assets/images/catalog-cat.png";
const CategoryCardWrapper = styled(Card)`
  min-height: 300px;
  .ant-card-body {
    padding: 0;
  }
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
  // margin-bottom:${(props) => (props.StorePreview ? "0px" : "20px")}
  margin-top: ${(props) => (props.StorePreview ? "10px" : "30px")};
`;
export default function Category({
  categorey,
  abc,
  isLoadingCategory,
  isImageTrue,
  StorePreview,
  categoryName,
}) {
  const [isBorder, setBorder] = useState("");
  useEffect(() => {
    setBorder(categoryName);
  }, [categoryName]);

  return (
    <Row>
      <Col xl={24} xs={24} sm={24}>
        <CategoryCardWrapper
          categorayName={isBorder}
          StorePreview={StorePreview}
        >
          <Row justify="start">
            {isImageTrue ? (
              <Col
                span={12}
                style={{
                  position: "relative",
                  padding: "15px",
                }}
                className="text-left"
              >
                <img
                  src={Catalog}
                  style={{
                    width: "100%",
                    position: "absolute",
                    backgroundRepeat: "no-repeat",
                    top: "-20px",
                  }}
                />
              </Col>
            ) : (
              <Col xl={14}>
                <h5 className="text-left" style={{ padding: "15px" }}>
                  Categories
                </h5>
              </Col>
            )}
          </Row>
          {isLoadingCategory ? (
            <img src={LoaderGif} height={"60"} width={"60"} />
          ) : (
            (categorey || []).map((item) => {
              return (
                <Row
                  justify="start"
                  style={{
                    border:
                      isBorder === item.name ? "solid 1px #09c1b2" : "none",
                    background: isBorder === item.name ? "#f1f1f1" : "none",
                  }}
                  className="primary-color category-border pointer-cursor"
                  onClick={() => {
                    setBorder(item.name);
                    abc(item);
                  }}
                >
                  <Col xl={24}>
                    <h2 className="text-left pointer-cursor categories-heading">
                      {item.name}
                    </h2>
                  </Col>
                </Row>
              );
            })
          )}
        </CategoryCardWrapper>
      </Col>
    </Row>
  );
}
